import { Flex } from "antd";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import AppButton from "../../common/AppButton";
import WarehouseReceivingZoneForm from "./WarehouseReceivingZoneForm";
import WarehouseReceivingZonesTable from "./WarehouseReceivingZonesTable";

const WarehouseReceivingZonesPanel = () => {
  const { state: { warehouseId } } = useLocation();
  const [isModifying, setIsModifying] = useState(false);
  const [receivingZoneId, setReceivingZoneId] = useState(null);

  const handleIsModifying = () => setIsModifying(!isModifying);

  const handleReceivingZoneIdChange = (receivingZoneId) => {
    setReceivingZoneId(receivingZoneId);
  };

  return (
    <>
      {isModifying ?
        (<Flex justify="center">
          <WarehouseReceivingZoneForm warehouseId={warehouseId}
                                      receivingZoneId={receivingZoneId}
                                      handleReceivingZoneIdChange={handleReceivingZoneIdChange}
                                      handleIsModifying={handleIsModifying} />
        </Flex>) :
        (<>
          <AppButton className="panel-new-button" variant="new" onClick={() => setIsModifying(true)}>
              New
          </AppButton>
          <WarehouseReceivingZonesTable handleModifying={handleIsModifying}
                                        handleReceivingZoneIdChange={handleReceivingZoneIdChange} />
        </>)
      }
    </>
  );
};

export default WarehouseReceivingZonesPanel;